import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

import instagram_square from '../../../assets/img/instagram-square.png';


class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Contact Us </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      <b>Custom development</b>
                      <br></br>
                      If you are a business owner and want to use XR in your business, we are here to help you.
                      Please visit our <a href="/customdev">Custom Development</a> guidelines and 
                      email us on: contact@icomputinglabs.in.
                      <br />
                      We promise to get back to you within 24 hours.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Customer Care</b>
                      <br></br>
                      If you are a user of AbilitàXR and have any queries, or want to report a bug, 
                      or want to appreciate our product, or just want to drop a line to say hello, 
                      please email us on: contact@icomputinglabs.in.
                      <br></br>
                      We promise to get back to you within 24 hours.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <b>Complaint</b>
                      <br></br>
                      If you have any complaints or have any issues with any of the content 
                      that is displayed on the site, then you can again contact us at 
                      contact@icomputinglabs.in and request to raise a complaint.
                      <br></br>
                      If your concern still remains unresolved, please drop an email to: manish@icomputinglabs.in.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      AbilitàXR is brought to you by iComputinglabs Technologies Private Limited (CIN: U72900KA2017PTC106154). 
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                    <h6 className = "mt-4 line-height-h">
                      <br></br><br></br>
                    </h6>
                  </Col>
                </Row>
                {/* -------------- Footer Start -------- */}
                <Row className="mt-5">
                </Row>
                <Row className="pt-5 pb-5 home-background-gray">
                  <Col xs="0" sm="0" lg="1">
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "ml-2 text-left">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>PRODUCT</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                         <a href = "/feature"><div className = "font-size-10" >Features & Roadmap</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/appguide"><div className = "font-size-10" >Solutions</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/customdev"><div className = "font-size-10" >Professional Services</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/pricing"><div className = "font-size-10" >Pricing</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div >USE CASES</div>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/education"><div className = "font-size-10" >Education</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/training"><div className = "font-size-10" >Training</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/retail"><div className = "font-size-10" >Retail</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/ecommerce"><div className = "font-size-10" >Ecommerce</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>Support</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "http://www.icomputinglabs.in/blog/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Blog</div> </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/faq"><div className = "font-size-10" >FAQ</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/contact"><div className = "font-size-10" >Contact</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>COMPANY</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/about"><div className = "font-size-10" >About</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/privacy"><div className = "font-size-10" >Privacy Policy</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/tos"><div className = "font-size-10" >Terms of Service</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>GET CONNECTED</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.facebook.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-facebook-square fa-lg mr-2" />facebook</div>
                        </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.instagram.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><img  alt="" src={instagram_square} className = "text-primary width-16 mr-2" />instagram</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://twitter.com/iComputingLabs" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-twitter-square fa-lg mr-2" />twitter</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'>
                        <a href = "https://www.linkedin.com/company/13404850/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-linkedin-square fa-lg mr-2" />linkedin</div>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              {/* -------------- Footer End -------- */}
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/views/Pages/Contact/Contact.js